export const faqDonateUs = [
  {
    title:
      "How many Development Entrepreneurs does The Buddha Institute support?",

    content:
      "As of 2024, The Buddha Institute has recruited 46 fellows, including 12 women. These Development Entrepreneurs work across sectors such as farm produce, forest produce, handicrafts, and climate mitigation. They come from 16 states in India and are actively engaged with underserved communities in rural and semi-rural areas.",
  },
  {
    title: "What support does The Buddha Institute provide to Fellows?",

    content:
      "We offer time, guidance, and funding to nurture each Buddha Fellow. Every Fellow is paired with an Anchor and a dedicated Mentor, who provide personalized support on business strategy, financial planning, and social impact. Our funding model is tied to milestone achievements, and we grant Fellows access to key government and private networks. We remain committed to their growth until they achieve scalable business success and measurable social impact.",
  },
  {
    title: "What kind of businesses do the Buddha Fellows have?",

    content:
      "The Buddha Fellows run social impact-first, for-profit enterprises in various domains (Millets, Edible Oils, Regenerative Agriculture, Forest Produce, Food Processing and Marketing, AgriTech, Livestock, Handicrafts, Recycling, and Gig Economy). Despite their diversity, all businesses share a commitment to:  <br/> • Directly impacting the lives of underserved communities.  <br/> • Demonstrating potential to positively impact at least 25,000 lives within five years.  <br/> • Tracking both business performance and social outcomes.",
  },
  {
    title:
      "What kind of impact have the Buddha Fellows had on the community so far?",

    content:
      "We measure impact through three key parameters: <br/> • Lives uplifted: Over 125,000 people have benefited from the Fellows' initiatives. <br/> •  Jobs created: 130 new jobs have been generated. <br/> •  Average income growth: Beneficiaries' average annual income has doubled to approximately $4,000 (around $10.9 per day). <br/>  Up until 2024, our Buddha Fellows have collectively impacted over 500,000 lives, created 2044 jobs, and multiplied the average annual income of their beneficiaries to approximately $4000 or $10.9 per day.",
  },
  {
    title: "Where does my money go?",

    content:
      "The overall cost of each Buddha Fellow to the institute is INR 25 lacs ($ 30,000), 85% of which is directly invested in building the capacity of the Buddha Fellow. ",
  },
  {
    title: "Is my donation tax-deductible?",

    content:
      "Yes! Contributions are tax-deductible in both India and the USA: <br/> • The USA: Donations are eligible for tax exemption under IRS 501(c)(3) through Friends of Buddha Fellowship (FOBF), Inc. <br/> • India: Education for Employability Foundation (E2F) has tax exemption under 80G and 12 A of Income Tax Act of India.",
  },
  {
    title:
      "Are there other ways in which I can contribute besides donating money?",

    content:
      "Absolutely! You can support us through Tan (Time), Mann (Mind), and Dhan (Wealth). You can join us as a Mentor, Anchor, expert, volunteer or fundraiser. Please write to us at <a href='mailto:communications@thebuddhainstitute.org' class='text-darkCyan border-b-[1px] border-darkCyan'> communications@thebuddhainstitute.org</a> to find more ways of getting involved.",
  },
];
